module.exports = __webpack_public_path__ + "static/media/twitter.f61abab8.svg";